export const EXPERIENCES = 'Experiences';
export const TEMPLATES = 'Templates';
export const REVIEWS = 'Reviews';

export const MODERATE_TAB_MENU = [
  {label: EXPERIENCES, id: 'menu0', checked: true, value: EXPERIENCES},
  {label: TEMPLATES, id: 'menu1', checked: false, value: TEMPLATES},
  {label: REVIEWS, id: 'menu2', checked: false, value: REVIEWS},
];
